import React from "react";

const TermsConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>
      <p className="mb-4">
        By accessing and using our service, you agree to comply with these Terms
        and all applicable laws and regulations. If you disagree with any part
        of the terms, you may not access the service.
      </p>
      <p className="mb-4">
        Our service allows users to repurpose blog content into tweets, threads,
        and other formats. You are responsible for the content you generate and
        share using our tool.
      </p>
      <p className="mb-4">
        We reserve the right to modify or terminate the service at any time
        without notice.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">Privacy Policy</h2>
      <p className="mb-4">
        We collect minimal user information (such as email address) to provide
        access to our SaaS features. We do not sell or share your data with
        third parties.
      </p>
      <p className="mb-4">
        Data is stored securely, and we follow standard industry practices to
        protect your information. You may request deletion of your data at any
        time by contacting us.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">Refund Policy</h2>
      <p className="mb-4">
        We offer a 7-day refund policy for all new subscriptions. If you are not
        satisfied with the service, please contact us within 7 days of purchase
        at{" "}
        <a
          href="mailto:info@blogslicer.com"
          className="text-blue-600 underline"
        >
          info@blogslicer.com
        </a>
        .
      </p>
      <p className="mb-4">
        Refunds will not be issued after the 7-day window, except in cases of
        technical failure directly caused by our platform.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">Contact</h2>
      <p className="mb-4">
        If you have any questions about these policies, feel free to reach out
        at{" "}
        <a
          href="mailto:info@blogslicer.com"
          className="text-blue-600 underline"
        >
          info@blogslicer.com
        </a>
        .
      </p>

      <div className="mt-10 text-sm text-gray-600">
        <p>
          This service is operated by <strong>Umesh Khanna M</strong>, the sole
          proprietor and founder of BlogSlicer.
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
